import React, {FC, useEffect} from "react";
import { EditorProvider } from "../../../store/editor/context";
import FixtureContent from "../../fixtureContent";
import { PlayerProvider } from "../../../store/player/context";
import { FixtureMetadataProvider } from "../../../store/fixtureMetadata/context";

import styles from "./fixturePage.module.scss";
import {useMixPanel} from "../../../logging_config/Mixpanel";
import {EditorAnglesProvider} from "../../../store/editorAngles/context";

export interface FixturesProps {}

const FixturePage: FC<FixturesProps> = () => {
    const mixpanel = useMixPanel()

    useEffect(() => {
        const handleUnload = () => {
            mixpanel.track("Fixture Page - Reloaded");
        };

        window.addEventListener("unload", handleUnload);

        return () => {
            window.removeEventListener("unload", handleUnload);
        };
    }, [mixpanel]);

    return (
        <div className={styles.fixturePageParentContainer}>
            <div className={styles.fixturePageChildContainer}>
                    <FixtureMetadataProvider>
                        <PlayerProvider>
                            <EditorProvider>
                                <EditorAnglesProvider>
                                    <FixtureContent/>
                                </EditorAnglesProvider>
                            </EditorProvider>
                        </PlayerProvider>
                    </FixtureMetadataProvider>
            </div>
        </div>
    );
};

export default FixturePage;
